import { config } from './config'
import { getHttpClientToken, httpClient } from './http-client'

export async function logout(): Promise<void> {
  const tokenId = getHttpClientToken()
  return httpClient.delete(`${config.apiUrl}/tokens/${tokenId}`)
}
